import React from 'react';
import * as Card from '../../v2BaseComponents/Card';
import { getIntl } from '../../../utils/intl';
import { getPermissionsDescription } from '../../../utils/evaluatePermissions';
import getDateString from '../../../utils/getDateString';
import useMedicalProfileInvitation from '../../../hooks/api/useMedicalProfileInvitation';

const intl = getIntl('InvitationCard', {
    profileAccess: 'Profile Access',
    view: 'View',
    edit: 'Edit',
    none: 'None',
    permissions: 'Permissions: {permissions}',
    invitedOn: 'Invited on',
});

export type InvitationCardOwnProps = {
    medicalProfileId: string;
    invitationId: string;
    onPress?: () => void;
    isDisabled?: boolean;
    skeletonFallback?: boolean;
};

export type InvitationCardProps = InvitationCardOwnProps;

const InvitationCard: React.FC<InvitationCardProps> = (props) => {
    const { isLoading, invitation } = useMedicalProfileInvitation({
        medicalProfileId: props.medicalProfileId,
        invitationId: props.invitationId,
    });

    if (!invitation || isLoading) return props.skeletonFallback ? <Card.CardSkeleton /> : null;

    const getDetails = (): string => {
        // @ts-expect-error TS2345
        return intl('permissions', { permissions: getPermissionsDescription(invitation.appPermissions) });
    };

    return (
        <Card.Card onPress={props.onPress} isDisabled={props.isDisabled}>
            <Card.CardContent>
                <Card.CardHeader>{invitation.email}</Card.CardHeader>
                <Card.CardBody>{getDetails()}</Card.CardBody>
                <Card.CardBody2>
                    {`${intl('invitedOn')}: ${getDateString(invitation.createDate, 'date-time')}`}
                </Card.CardBody2>
            </Card.CardContent>
        </Card.Card>
    );
};

export default React.memo(InvitationCard);
